import { combineReducers } from "@reduxjs/toolkit";
import loads from "./loadsSlice";

const reducer = combineReducers({
	loads,
});

export default reducer;
